module.exports = __webpack_public_path__ + "static/media/medium-set.d20b2918.png";